document.addEventListener("DOMContentLoaded", function () {

  function addCollectionCounts() {

    if (!window.collectionCounts) return;

    document.querySelectorAll(
      '.meteor-menu[data-meteor-template="tidal"] a'
    ).forEach(function(link) {

      let url = link.getAttribute('href');

      if (!url) return;

      let match = url.match(/collections\/([^/?]+)/);

      if (!match) return;

      let handle = match[1];
      let count = window.collectionCounts[handle];

      if (count && !link.querySelector('.meteor-product-count')) {

        let span = document.createElement('span');
        span.className = 'meteor-product-count';
        span.textContent = ' (' + count + ')';

        link.appendChild(span);
      }

    });
  }


  // Premier chargement
  addCollectionCounts();


  // Surveille les changements de Meteor
  const observer = new MutationObserver(function() {
    addCollectionCounts();
  });


  observer.observe(document.body, {
    childList: true,
    subtree: true
  });


});